import en from './en.json';
import pt_BR from './pt_BR.json';

export default { en, pt_BR };
